export default {
  name: "403"
};